import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,setUpdateButtonActiveStepToTrue} from '../../../../store/actions/main';
import {updateAntrieb, updateStepsTore} from '../../../../store/actions/tore';
import {InputRadio} from '../../../../module/inputRadio';

const Step_6 = (props) => {
  let [antrieb, selectAntrieb] = useState('');

    useEffect(() => {
      updateItems();
    })

   const updateItems = () => {
      const {antrieb} = props.data[props.modell_index];

      selectAntrieb(antrieb);

      //update steps
      props.updateStepsTore(5);
      if(antrieb) props.updateStepsTore(6);

      if(antrieb || props.data[props.modell_index].allVisitedSteps) {
        props.setUpdateButtonActiveStepToFalse();
      } else {
        props.setUpdateButtonActiveStepToTrue();
      }


   }

   const updateAntrieb = ev => {
      let antrieb = ev.target.value;
      props.updateAntrieb(antrieb);
      updateItems();

   }

   const arrayRadioItems = [
      {labalValue: 'Manuell', labelTitel: 'Manuell'},
      {labalValue: 'Elektrisch', labelTitel: 'Elektrisch'}
   ]

   return (
           <div className="step_wrapper">
             <h2 className="step_header">Was für einen Antrieb benötigen Sie?</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper antrieb">
                    <InputRadio
                        onChange={updateAntrieb}
                        value={antrieb}
                        name='Beschichtung'
                        arial_label='Beschichtung'
                        arrayRadioItems={arrayRadioItems}
                    />
                </div>
              </div>
          </div>
   )
}

const mapStateToProps = state => {
    return {
      data: state.toreReducer.data,
      modell_index: state.toreReducer.modell_index
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      updateAntrieb: ev => dispatch(updateAntrieb(ev)),
      updateStepsTore: ev => dispatch(updateStepsTore(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_6);
